import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { loadAgreementDocuments, loadAppliedApplicationsJobDetails } from "../../requests/applicationApplied";
import { get } from "lodash";
import { useTranslation } from "react-i18next";
import { EmptyList, Loading } from "qjumpers.common.ui";
import { useHistory } from "react-router-dom";
import { downloadDocument, updateDocumentStatus } from "../../requests/agreementdocuments";
import { errorState } from "../../recoil/error/atom";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { downloadPdfFromBase64Data, downloadZipFromBase64Data } from "../../utils/documentsHelper";
import { toggleHandsetColumnButton } from "../../utils/uiHelper";
import { Alert, Button } from "react-bootstrap";
import { downloadAllDocuments } from "../../requests/documents";
import { candidateId as candidateIdFromAtom } from "../../recoil/candidate/atom";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { documentInViewState } from "../../recoil/agreementdocuments/atom";
import { noteTypesData } from "../../recoil/notetypes/atom";
import { NoteFormWrapper } from "../commonWrapper/noteFormWrapper";

const documentStatusType = ["", "Not Opened", "Reviewed", "Completed"];
const AgreementDocumentsList = () => {
  const params = useParams();
  const { t } = useTranslation();
  const history = useHistory();
  const popError = useSetRecoilState(errorState);
  const viewAgreementDocument = useSetRecoilState(documentInViewState);
  const [pageInfo, setPageInfo] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isDownloadingDocuments, setIsDownloadingDocuments] = useState(false);
  const [allSectionsSigned, setAllSectionsSigned] = useState(false);
  const [documents, setDocuments] = useState();
  const notesTypes = useRecoilValue(noteTypesData);
  const candidateIdAtom = useRecoilValue(candidateIdFromAtom);
  const loadData = () => {
    loadAppliedApplicationsJobDetails(params.applicationId).then((result) => {
      if (result.data) {
        const response = result.data;

        const jobDetails = {
          jobTitle: get(response, "job.title", ""),
          jobId: get(response, "job.id", ""),
          jobLocation: `${response.address?.placeName ? get(response.address, "placeName", "") : ""} ${get(response.address, "region", "")}`,
          jobReferenceId: response.job.jobReferenceId,
          organisationId: response.job.organisationId,
        };

        let listInfo = {
          candidateId: response.candidateId,
          applicationId: params.applicationId,
          jobDetails: jobDetails,
        };
        setPageInfo(listInfo);

        loadAgreementDocuments(listInfo.candidateId, listInfo.jobDetails.jobId, listInfo.jobDetails.organisationId)
          .then((result) => {
            if (result.data) {
              setDocuments(result.data);
            }

            setIsLoading(false);
          })
          .catch((error) => {
            setIsLoading(false);
          });
      }
    });
  };

  useEffect(() => {
    localStorage.removeItem("allSectionsSigned");
    loadData();
    const allSectionsSignedLS = localStorage.getItem("allSectionsSigned");
    if (allSectionsSignedLS == "true") {
      setAllSectionsSigned(true);
    }
  }, [candidateIdAtom]);

  const getDocumentReceivedDate = (cell, row) => t("ShortDateValue", { date: row.modifiedDate });
  const getDocumentExpiryDate = (cell, row) => t("ShortDateValue", { date: row.expiryDate });

  const getDocumentStatus = (cell, row) => {
    switch (row.status) {
      case 0:
      case 1:
        return documentStatusType[row.status];
      case 2:
        if (allSectionsSigned === true) {
          return (
            <div>
              <span>{documentStatusType[3]}</span> <span>{"("}</span>
              <span>{t("ShortDateValue", { date: row.documentStatusUpdatedDate })}</span>
              <span>{")"}</span>
            </div>
          );
        } else {
          return (
            <div>
              <span>{documentStatusType[row.status]}</span> <span>{"("}</span>
              <span>{t("ShortDateValue", { date: row.documentStatusUpdatedDate })}</span>
              <span>{")"}</span>
            </div>
          );
        }
      case 3:
        return (
          <div>
            <span>{documentStatusType[row.status]}</span> <span>{"("}</span>
            <span>{t("ShortDateValue", { date: row.documentStatusUpdatedDate })}</span>
            <span>{")"}</span>
          </div>
        );
      default:
        return "";
    }
  };

  const redirectToSignDocument = (document, status) => {
    const { candidateId, applicationId, jobDetails } = pageInfo;
    let previewDocument = {
      candidateId,
      applicationId,
      document,
      jobDetails,
      status,
    };
    viewAgreementDocument(previewDocument);
    // this.props.viewAgreementDocument(previewDocument);

    history.push(`/application/previewdocument/${document.id}`);
  };

  const openAgreementDocument = (document, data) => {
    if (document.status !== 2 && document.status !== 3 && document.status !== 0) {
      updateDocumentStatus(data, document.id).then(() => {
        redirectToSignDocument(document, 2);
      });
    } else {
      redirectToSignDocument(document, document.status);
    }
  };

  const reviewDocument = (document) => {
    const { candidateId, jobDetails } = pageInfo;
    const data = {
      organisationId: jobDetails.organisationId,
      updateToStatus: 2,
      candidateId: candidateId,
      jobId: jobDetails.jobId,
      isTouchSignatureUI: false,
      signatureContent: null,
      currentTimeStamp: null,
    };

    if (document.name === "KS2 - Kiwisaver Deduction Form" && document.status !== 3) {
      popError([
        {
          type: "info",
          title: t("AgreementDocuments.KS2.Title"),
          message: t("AgreementDocuments.KS2.OptOutMessage"),
          confirmBtnText: t("Action.Close"),
          showCancel: false,
          confirmBtnBsStyle: "success",
          onConfirm: () => {
            openAgreementDocument(document, data);
          },
        },
      ]);
    } else if (document.name === "KS10 - Kiwisaver Opt out Request" && document.status !== 3) {
      popError([
        {
          type: "info",
          title: t("AgreementDocuments.KS10.Title"),
          message: t("AgreementDocuments.KS10.OptOutMessage"),
          confirmBtnText: t("Action.Close"),
          showCancel: false,
          confirmBtnBsStyle: "success",
          onConfirm: () => {
            openAgreementDocument(document, data);
          },
        },
      ]);
    } else {
      openAgreementDocument(document, data);
    }
  };

  const downloadJobDescriptionDOcument = (object) => {
    let fileExtention = object.url.substring(object.url.lastIndexOf(".") + 1, object.url.length) || object.url;
    if (fileExtention.toLowerCase() !== "pdf") {
      const downloadLink = document.createElement("a");
      const fileName = object.name;
      downloadLink.href = object.url;
      downloadLink.download = fileName;
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
      setIsDownloadingDocuments(false);
    } else {
      setIsDownloadingDocuments(true);
      downloadDocument(object.id).then((response) => {
        downloadPdfFromBase64Data(response.pdfContent, object.name);
        setIsDownloadingDocuments(false);
      });
    }
  };

  const openDocument = (object) => {
    setIsDownloadingDocuments(true);

    if (object.status < 1) {
      downloadJobDescriptionDOcument(object);
    } else {
      downloadDocument(object.id).then((response) => {
        downloadPdfFromBase64Data(response.data.pdfContent, object.name);
        setIsDownloadingDocuments(false);
      });
    }
  };

  const getActionButton = (cell, row) => {
    const { jobDetails, candidateId } = pageInfo;
    return (
      <div style={{ textAlign: "right" }}>
        <Button
          variant="outline-secondary"
          disabled={row.status < 1}
          size="sm"
          onClick={() => reviewDocument(row)}>
          {t("Action.View")}
        </Button>
        <Button
          variant="outline-secondary"
          data-testid="downloadTest"
          size="sm"
          onClick={() => openDocument(row)}
        >
          <span className="qjicon-down" style={{ marginRight: "0px" }} />
        </Button>
        <span style={{ display: "inline-block" }}>
          <NoteFormWrapper
            hasCommunicationRights={true}
            hasManageRights={true}
            supportATSOperations={true}
            relatedObject={row}
            noteTypes={notesTypes}
            candidateId={candidateId}
            jobId={jobDetails.jobId}
            initialValues={{
              note: {
                entityType: "EmploymentDocuments",
                entityId: row.id,
              },
            }}
            showNotesButton={true}
          />
        </span>
      </div>
    );
  };

  const downloadAllDocumentsForJob = (candidateId, jobId) => {
    setIsDownloadingDocuments(true);
    downloadAllDocuments(candidateId, jobId).then((response) => {
      const fileName = "Employment Agreement and Offer Documents.zip";
      downloadZipFromBase64Data(response.data.pdfContent, fileName);
      setIsDownloadingDocuments(false);
    });
  };

  const { jobDetails, candidateId } = pageInfo;
  const documentStatus = documents && documents.length > 0 && documents.filter((el) => el.status < 3 && el.status > 0);

  return (
    <div className="dashboard-list--header">
      {documentStatus?.length > 0 && (
        <div className="row">
          <Alert variant="warning">
            <center>
              <strong>{t("AgreementDocuments.pendingSignatureErrorMessage")}</strong>
            </center>
          </Alert>
        </div>
      )}
      <div className="row">
        <div className="col-xs-12 col-sm-8 col-md-8">
          <h2>Employment Agreement and Offer Documents</h2>
          <div>
            {" "}
            {`Job Title: ${get(jobDetails, "jobTitle", "")} | Location : ${get(
              jobDetails,
              "jobLocation",
              ""
            )} | Job ID : ${get(jobDetails, "jobReferenceId", "")}`}
          </div>
        </div>
      </div>
      <Loading className="loading-component" isLoading={isDownloadingDocuments} />
      <Loading className="loading-component" isLoading={isLoading}>
        {documents && documents.length > 0 ? (
          <BootstrapTable
            data={documents}
            bordered={false}
            pagination={true}
            options={{
              sizePerPage: 10,
              sizePerPageList: [10, 20, 30, 40, 50],
              prePage: "Prev", // Previous page button text
              nextPage: "Next", // Next page button text
            }}>
            <TableHeaderColumn width="20%" dataField="name">
              Document Name
            </TableHeaderColumn>
            <TableHeaderColumn width="20%" dataFormat={getDocumentReceivedDate}>
              Received Data
            </TableHeaderColumn>
            <TableHeaderColumn width="20%" dataFormat={getDocumentExpiryDate}>
              Expiry Date
            </TableHeaderColumn>
            <TableHeaderColumn width="10%" dataFormat={getDocumentStatus}>
              Status
            </TableHeaderColumn>
            <TableHeaderColumn dataFormat={getActionButton} />
            <TableHeaderColumn dataField="id" isKey hidden>
              ID
            </TableHeaderColumn>
            <TableHeaderColumn
              dataFormat={toggleHandsetColumnButton}
              columnClassName="mobileToggleColumn hidden-sm hidden-md hidden-lg"
            />
          </BootstrapTable>
        ) : (
          <div style={{ marginTop: "30px" }}>
            <EmptyList />
          </div>
        )}
      </Loading>
      {documents && documents?.length > 0 ? (
        <div className="pull-right">
          <Button
            disabled={!documents?.length}
            variant="info"
            size="sm"
            onClick={() => downloadAllDocumentsForJob(candidateId, jobDetails?.jobId)}>
            Download All
          </Button>
        </div>
      ) : null}
    </div>
  );
};

export default AgreementDocumentsList;
